
/*
    Estados de la evaluación del desempeño
    - Pendiente Cargar Objetivos: El empleado debe cargar sus objetivos para iniciar con el proceso. Esta etapa corresponde al 1Q.
    - Registrar objetivos: 
    - Revision jefe: El jefe debe revisar los objetivos que el empleado ha registrado. Esta etapa corresponde al 1 Y 2Q siempre después de que el empleado hace clic en "Enviar a Revisión".
    - Jefe no acepta objetivos: El jefe ha rechazado los objetivos del empleado, quien debe editarlos. Esta etapa corresponde al 1 y 2Q siempre que el jefe hace clic en "Rechazar".
    - Jefe acepta objetivos: El jefe ha aprobado los objetivos del empleado. Esta etapa corresponde al 1Q luego de que el jefe hace clic en "Aprobar".
    - Pendiente Revisión: La evaluación está pendiente de revisión a mitad de año. Esta etapa aparece el día de la revisión de mitad de año (2Q). Permite que el jefe pueda solicitar o no ajustes en los objetivos.
    - Revision En Proceso: El jefe ha solicitado ajustes en los objetivos, y el empleado debe editarlos.
    - Pendiente Cerrar Revision: Los objetivos han sido aprobados en el 2Q y el jefe y empleado deben hacer clic en el check de retroalimentación en el monitor de las evaluaciones.
    - Pendiente Cargar Plan De Accion: El empleado debe cargar el plan de acción solo si fue solicitado por el jefe al finalizar la revisión de mitad de año. Esta etapa corresponde al 2Q.
*/

export const STATUSES = {
    PENDIENTE_CARGAR_OBJETIVOS: 'Pendiente Cargar Objetivos',
    REGISTRAR_OBJETIVOS: 'Registrar objetivos',
    REVISION_JEFE: 'Revision jefe',
    JEFE_NO_ACEPTA_OBJETIVOS: 'Jefe no acepta objetivos',
    JEFE_ACEPTA_OBJETIVOS: 'Jefe acepta objetivos',
    PENDIENTE_REVISION: 'Pendiente Revision',
    REVISION_EN_PROCESO: 'Revision En Proceso',
    PENDIENTE_CERRAR_REVISION: 'Pendiente Cerrar Revision',
    PENDIENTE_CARGAR_PLAN_DE_ACCION: 'Pendiente Cargar Plan De Accion',
    REVISION_MITAD_ANIO_REALIZADA: 'Revision Mitad Año Realizada',
    PENDIENTE_EVALUACION: "Pendiente Evaluacion",
    PENDIENTE_CERRAR_EVALUACION: "Pendiente Cerrar Evaluacion",
    EVALUACION_COMPLETADA: "Evaluacion completada"
}


export const FORM_TYPES = {
    OBJECTIVES: 'Formulario por Objetivos',
    COMPETENCIES: 'Formulario por Valores',
    VALUES: 'Formulario por Competencias'
}

export const getEmployeeEvaluationActions = (status) => {
    switch (status) {
        case STATUSES.PENDIENTE_CARGAR_OBJETIVOS:
            return "Cargar Objetivos"
        case STATUSES.JEFE_NO_ACEPTA_OBJETIVOS:
            return "Editar Objetivos"
        case STATUSES.REVISION_EN_PROCESO:
            return "Editar Objetivos"
        case STATUSES.PENDIENTE_EVALUACION:
            return "Realizar Evaluación"
        default:
            return "Ver Evaluación";
    }
}

export const getBossEvaluationActions = (status) => {
    switch (status) {
        case STATUSES.REVISION_JEFE:
            return "Aprobar"
        case STATUSES.PENDIENTE_REVISION:
            return "Realizar Revisión"
        case STATUSES.PENDIENTE_EVALUACION:
            return "Realizar Evaluación"
        default:
            return "Ver Evaluación";
    }
}


export const EMPLOYEE_MESSAGES = {
    REVISION_JEFE: {
        name: STATUSES.REVISION_JEFE,
        message: 'Su evaluación está en revisión por su jefe.',
        color: "primary"
    },
    JEFE_ACEPTA_OBJETIVOS: {
        name: STATUSES.JEFE_ACEPTA_OBJETIVOS,
        message: 'Sus objetivos han sido aprobados. Espere a mitad de año para continuar con el proceso de evaluación.',
        color: "success"
    },
    JEFE_NO_ACEPTA_OBJETIVOS: {
        name: STATUSES.JEFE_NO_ACEPTA_OBJETIVOS,
        message: 'Sus objetivos no han sido aprobados. Por favor, edite sus objetivos. Su jefe ha dejado el siguiente comentario: ',
        color: "danger"
    },
    PENDIENTE_REVISION: {
        name: STATUSES.PENDIENTE_REVISION,
        message: 'La revisión de mitad de año está pendiente. Espere a que su jefe realice la revisión.',
        color: "info"
    },
    REVISION_EN_PROCESO: {
        name: STATUSES.REVISION_EN_PROCESO,
        message: 'Su jefe ha solicitado que ajuste sus objetivos. Por favor, edítelos y envíelos nuevamente para su aprobación.',
        color: "danger"
    },
    PENDIENTE_CERRAR_REVISION: {
        name: STATUSES.PENDIENTE_CERRAR_REVISION,
        message: 'Sus objetivos han sido aprobados. Por favor, haga clic en el check de "Retroalimentación Mitad Año" en el monitor de evaluaciones para finalizar el proceso.',
        color: "success"
    },
    PENDIENTE_CARGAR_PLAN_DE_ACCION: {
        name: STATUSES.PENDIENTE_CARGAR_PLAN_DE_ACCION,
        message: 'Debe cargar el plan de acción.',
        color: "warning"
    },
    REVISION_MITAD_ANIO_REALIZADA: {
        name: STATUSES.REVISION_MITAD_ANIO_REALIZADA,
        message: 'La revisión de mitad de año ha sido realizada.',
        color: "info"
    },
    PENDIENTE_EVALUACION: {
        name: STATUSES.PENDIENTE_EVALUACION,
        message: "Su evaluación está pendiente.",
        color: "warning"
    },
    PENDIENTE_CERRAR_EVALUACION: {
        name: STATUSES.PENDIENTE_CERRAR_EVALUACION,
        message: 'Su evaluación está pendiente de cierre. Por favor, haga clic en el check de "Retroalimentación Final" en el monitor de evaluaciones para finalizar el proceso.',
        color: "info"
    },
    EVALUACION_COMPLETADA: {
        name: STATUSES.EVALUACION_COMPLETADA,
        message: "Su evaluación ha sido completada.",
        color: "success"
    }
}

export const BOSS_MESSAGES = {
    PENDIENTE_CARGAR_OBJETIVOS: {
        name: STATUSES.PENDIENTE_CARGAR_OBJETIVOS,
        message: 'El colaborador debe cargar sus objetivos para iniciar con el proceso.',
        color: "warning"
    },
    REVISION_JEFE: {
        name: STATUSES.REVISION_JEFE,
        message: 'Debe revisar los objetivos del colaborador.',
        color: "info"
    },
    JEFE_NO_ACEPTA_OBJETIVOS: {
        name: STATUSES.JEFE_NO_ACEPTA_OBJETIVOS,
        message: 'El colaborador debe editar sus objetivos.',
        color: "danger"
    },
    JEFE_ACEPTA_OBJETIVOS: {
        name: STATUSES.JEFE_ACEPTA_OBJETIVOS,
        message: 'Ha aprobado los objetivos del colaborador. Espere a mitad de año para continuar con el proceso de evaluación.',
        color: "success"
    },
    PENDIENTE_REVISION: {
        name: STATUSES.PENDIENTE_REVISION,
        message: 'La revisión de mitad de año está pendiente. Debe realizar la revisión.',
        color: "info"
    },
    REVISION_EN_PROCESO: {
        name: STATUSES.REVISION_EN_PROCESO,
        message: 'El colaborador debe ajustar sus objetivos.',
        color: "danger"
    },
    PENDIENTE_CERRAR_REVISION: {
        name: STATUSES.PENDIENTE_CERRAR_REVISION,
        message: 'Los objetivos han sido aprobados. El colaborador y usted deben hacer clic en el check de "Retroalimentación Mitad Año" en el monitor de las evaluaciones para finalizar el proceso.',
        color: "success"
    },
    PENDIENTE_CARGAR_PLAN_DE_ACCION: {
        name: STATUSES.PENDIENTE_CARGAR_PLAN_DE_ACCION,
        message: 'El colaborador debe cargar el plan de acción.',
        color: "warning"
    },
    REVISION_MITAD_ANIO_REALIZADA: {
        name: STATUSES.REVISION_MITAD_ANIO_REALIZADA,
        message: 'La revisión de mitad de año ha sido realizada.',
        color: "info"
    },
    PENDIENTE_EVALUACION: {
        name: STATUSES.PENDIENTE_EVALUACION,
        message: "La evaluación está pendiente.",
        color: "warning"
    },
    PENDIENTE_CERRAR_EVALUACION: {
        name: STATUSES.PENDIENTE_CERRAR_EVALUACION,
        message: 'La evaluación está pendiente de cierre. El colaborador y usted deben hacer clic en el check de "Retroalimentación Final" en el monitor de las evaluaciones para finalizar el proceso.',
        color: "info"
    },
    EVALUACION_COMPLETADA: {
        name: STATUSES.EVALUACION_COMPLETADA,
        message: "La evaluación ha sido completada.",
        color: "success"
    }
}

export const ROLES = {
    EMPLOYEE: 'employee',
    BOSS: 'boss',
    ADMIN: 'admin'
}

export const QUARTERS = {
    FIRST: 'first_q',
    SECOND: 'second_q',
    THIRD: 'third_q'
}

export const EVALUATION_SPECIFIC_VIEWS = {
    EMPLOYEE_OBJECTIVES: 'employeeObjectives',
    EMPLOYEE_SEND_EVALUATION: 'employeeSendEvaluation',
    EMPLOYEE_EVALUATION_COLUMN: 'employeeEvaluationColumn',
    BOSS_ACCEPT_OBJECTIVES: 'bossAcceptObjectives',
    BOSS_EVALUATION_COLUMNS: 'bossEvaluationColumns',
    BOSS_EVALUATION_RESULTS: 'bossEvaluationResults',
    BOSS_COMPETENCY_EVALUATION: 'bossCompetencyEvaluation',
    BOSS_VALUE_EVALUATION: 'bossValueEvaluation'

}

export const PERMISSIONS = Object.freeze({
    [QUARTERS.FIRST]: {
        [STATUSES.PENDIENTE_CARGAR_OBJETIVOS]: {
            roles: {
                [ROLES.EMPLOYEE]: {
                    view: true, edit: true, editViews: [
                        EVALUATION_SPECIFIC_VIEWS.EMPLOYEE_OBJECTIVES,
                        EVALUATION_SPECIFIC_VIEWS.EMPLOYEE_SEND_EVALUATION
                    ]
                },
                [ROLES.BOSS]: { view: true, edit: false },
                [ROLES.ADMIN]: { view: true, edit: false }
            }
        },
        [STATUSES.REGISTRAR_OBJETIVOS]: {
            roles: {
                [ROLES.EMPLOYEE]: { view: true, edit: true },
                [ROLES.BOSS]: { view: true, edit: false },
                [ROLES.ADMIN]: { view: true, edit: false }
            }
        },
        [STATUSES.REVISION_JEFE]: {
            roles: {
                [ROLES.EMPLOYEE]: { view: true, edit: false },
                [ROLES.BOSS]: {
                    view: true, edit: true, editViews: [
                        EVALUATION_SPECIFIC_VIEWS.BOSS_ACCEPT_OBJECTIVES
                    ]
                },
                [ROLES.ADMIN]: { view: true, edit: false }
            }

        },
        [STATUSES.JEFE_NO_ACEPTA_OBJETIVOS]: {
            roles: {
                [ROLES.EMPLOYEE]: {
                    view: true, edit: true, editViews: [
                        EVALUATION_SPECIFIC_VIEWS.EMPLOYEE_OBJECTIVES,
                        EVALUATION_SPECIFIC_VIEWS.EMPLOYEE_SEND_EVALUATION
                    ]
                },
                [ROLES.BOSS]: { view: true, edit: false },
                [ROLES.ADMIN]: { view: true, edit: false }
            }
        },
        [STATUSES.PENDIENTE_REVISION]: {
            roles: {
                [ROLES.EMPLOYEE]: { view: true, edit: false },
                [ROLES.BOSS]: { view: true, edit: false },
                [ROLES.ADMIN]: { view: true, edit: false }
            }
        }
    },
    [QUARTERS.SECOND]: {
        [STATUSES.REVISION_JEFE]: {
            roles: {
                [ROLES.EMPLOYEE]: { view: true, edit: false },
                [ROLES.BOSS]: { view: true, edit: true },
                [ROLES.ADMIN]: { view: true, edit: false }
            }
        },
        [STATUSES.REVISION_EN_PROCESO]: {
            roles: {
                [ROLES.EMPLOYEE]: {
                    view: true, edit: true, editViews: [
                        EVALUATION_SPECIFIC_VIEWS.EMPLOYEE_OBJECTIVES,
                        EVALUATION_SPECIFIC_VIEWS.EMPLOYEE_SEND_EVALUATION
                    ]
                },
                [ROLES.BOSS]: { view: true, edit: false },
                [ROLES.ADMIN]: { view: true, edit: false }
            }
        },
        [STATUSES.PENDIENTE_CERRAR_REVISION]: {
            roles: {
                [ROLES.EMPLOYEE]: { view: true, edit: false },
                [ROLES.BOSS]: { view: true, edit: false },
                [ROLES.ADMIN]: { view: true, edit: false }
            }
        },
        [STATUSES.PENDIENTE_CARGAR_PLAN_DE_ACCION]: {
            roles: {
                [ROLES.EMPLOYEE]: { view: true, edit: false },
                [ROLES.BOSS]: { view: true, edit: false },
                [ROLES.ADMIN]: { view: true, edit: false }
            }
        },
        [STATUSES.REVISION_MITAD_ANIO_REALIZADA]: {
            roles: {
                [ROLES.EMPLOYEE]: { view: true, edit: false },
                [ROLES.BOSS]: { view: true, edit: false },
                [ROLES.ADMIN]: { view: true, edit: false }
            }
        },
    },
    [QUARTERS.THIRD]: {
        [STATUSES.PENDIENTE_EVALUACION]: {
            roles: {
                [ROLES.EMPLOYEE]: {
                    view: true,
                    edit: true,
                    editViews: [
                        EVALUATION_SPECIFIC_VIEWS.EMPLOYEE_OBJECTIVES,
                        EVALUATION_SPECIFIC_VIEWS.EMPLOYEE_EVALUATION_COLUMN
                    ]
                },
                [ROLES.BOSS]: {
                    view: true,
                    edit: true,
                    editViews: [
                        EVALUATION_SPECIFIC_VIEWS.EMPLOYEE_OBJECTIVES],
                    views: [
                        EVALUATION_SPECIFIC_VIEWS.BOSS_EVALUATION_COLUMNS,
                        EVALUATION_SPECIFIC_VIEWS.BOSS_EVALUATION_RESULTS,
                        EVALUATION_SPECIFIC_VIEWS.BOSS_COMPETENCY_EVALUATION,
                        EVALUATION_SPECIFIC_VIEWS.BOSS_VALUE_EVALUATION
                    ]
                },
                [ROLES.ADMIN]: {
                    view: true,
                    edit: false,
                    views: [
                        EVALUATION_SPECIFIC_VIEWS.BOSS_EVALUATION_COLUMNS,
                        EVALUATION_SPECIFIC_VIEWS.BOSS_EVALUATION_RESULTS,
                        EVALUATION_SPECIFIC_VIEWS.BOSS_COMPETENCY_EVALUATION,
                        EVALUATION_SPECIFIC_VIEWS.BOSS_VALUE_EVALUATION
                    ]
                }
            }
        },
        [STATUSES.PENDIENTE_CERRAR_EVALUACION]: {
            roles: {
                [ROLES.EMPLOYEE]: { view: true, edit: false },
                [ROLES.BOSS]: {
                    view: true,
                    edit: false,
                    views: [
                        EVALUATION_SPECIFIC_VIEWS.BOSS_EVALUATION_COLUMNS,
                        EVALUATION_SPECIFIC_VIEWS.BOSS_EVALUATION_RESULTS,
                        EVALUATION_SPECIFIC_VIEWS.BOSS_COMPETENCY_EVALUATION,
                        EVALUATION_SPECIFIC_VIEWS.BOSS_VALUE_EVALUATION
                    ]
                },
                [ROLES.ADMIN]: {
                    view: true,
                    edit: false,
                    views: [
                        EVALUATION_SPECIFIC_VIEWS.BOSS_EVALUATION_COLUMNS,
                        EVALUATION_SPECIFIC_VIEWS.BOSS_EVALUATION_RESULTS,
                        EVALUATION_SPECIFIC_VIEWS.BOSS_COMPETENCY_EVALUATION,
                        EVALUATION_SPECIFIC_VIEWS.BOSS_VALUE_EVALUATION
                    ]
                }
            },

        },
        [STATUSES.EVALUACION_COMPLETADA]: {
            roles: {
                [ROLES.EMPLOYEE]: { view: true, edit: false },
                [ROLES.BOSS]: {
                    view: true,
                    edit: false,
                    views: [
                        EVALUATION_SPECIFIC_VIEWS.BOSS_EVALUATION_COLUMNS,
                        EVALUATION_SPECIFIC_VIEWS.BOSS_EVALUATION_RESULTS,
                        EVALUATION_SPECIFIC_VIEWS.BOSS_COMPETENCY_EVALUATION,
                        EVALUATION_SPECIFIC_VIEWS.BOSS_VALUE_EVALUATION
                    ]
                },
                [ROLES.ADMIN]: {
                    view: true,
                    edit: false,
                    views: [
                        EVALUATION_SPECIFIC_VIEWS.BOSS_EVALUATION_COLUMNS,
                        EVALUATION_SPECIFIC_VIEWS.BOSS_EVALUATION_RESULTS,
                        EVALUATION_SPECIFIC_VIEWS.BOSS_COMPETENCY_EVALUATION,
                        EVALUATION_SPECIFIC_VIEWS.BOSS_VALUE_EVALUATION
                    ]
                }
            }
        }
    }
});

const getQuarterConfig = (quarter) => PERMISSIONS[quarter] || {};
const getStatusConfig = (quarter, status) => (getQuarterConfig(quarter) || {})[status] || {};

const hasRolePermission = (statusConfig, role, action) => {
    if (!statusConfig) return false;
    const rolesObj = statusConfig.roles || statusConfig; // keep legacy compatibility
    return !!(rolesObj[role] && rolesObj[role][action]);
}

const toArray = (val) => Array.isArray(val) ? val : [val];

/**
 * canEdit
 * - role: ROLES.*
 * - quarters: string or array of quarter keys (e.g. 'first_q' or ['first_q','second_q'])
 * - status: string (one of STATUSES.*)
 * - specialCondition: optional object { condition: boolean, quarter: string } to add extra condition for a specific quarter
 */
export const canEdit = (role, quarters, status, specialCondition = null, editView = null) => {
    const quarterArray = toArray(quarters);
    return quarterArray.some(q => {
        if (specialCondition) {
            if (typeof specialCondition === 'object') {
                const { condition, quarter } = specialCondition;
                if (q === quarter && condition === false) return false;
            }
        }
        const s = getStatusConfig(q, status);
        if (!editView) return hasRolePermission(s, role, "edit");
        const allowed = s?.roles?.[role]?.editViews;
        if (allowed && allowed.includes(editView)) return true;

    });
}


/**
 * canView
 * - viewKey: identificador de vista ('managerColumns', 'autoevaluationColumn', etc.)
 * - role: ROLES.*
 * - quarters: string o array de strings
 * - status: string
 */
export const canView = (role, quarters, status, specialCondition = null, viewKey = null) => {
    const quarterArray = toArray(quarters);
    return quarterArray.some(q => {
        if (specialCondition) {
            if (typeof specialCondition === 'object') {
                const { condition, quarter } = specialCondition;
                if (q === quarter && condition === false) return false;
            }
        }
        const s = getStatusConfig(q, status);
        if (!viewKey) return hasRolePermission(s, role, 'view');
        const allowed = s?.roles?.[role]?.views;
        if (allowed && allowed.includes(viewKey)) return true;
    });
}


